import { ApiError } from '../api';

/**
 * Player-facing copy for a failed demo pull. The reveal machine toasts
 * whatever the pull rejects with, so these read as finished sentences.
 * NOT_FOUND and a disabled demo answer alike on purpose (the backend keeps
 * them indistinguishable) — don't branch further on the distinction.
 */
export function demoErrorMessage(err: unknown): string {
  if (err instanceof ApiError) {
    if (err.status === 429) return 'Too many free rips — try again in a moment.';
    if (err.code === 'DEMO_POOL_EMPTY') {
      return 'No demo cards available for this pack right now — try again later.';
    }
    if (err.status === 404) return 'This demo isn’t available right now.';
  }
  return 'Something went wrong. Please try again.';
}
